if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
      this.closeButton = this.drawer.querySelector('.side-panel-close');
    }

    connectedCallback() {
      this.setupObservers();
      this.handleEscapeKey();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
          setTimeout(() => {
    this.drawer.focus();
}, 1000); 

        });
      });

     
      if (this.closeButton) {
        this.closeButton.addEventListener('click', (e) => {
          this.closeDrawer();
        });
      }
    }

    handleEscapeKey() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('active')) {
          this.closeDrawer();
        }
      });
    }

    closeDrawer() {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.focusLastActiveButton();
    }

    focusLastActiveButton() {
  
      const activeButton = Array.from(this.links).find((link) => link.classList.contains('active'));
      if (activeButton) {
        activeButton.focus();
      } 
      else {
        this.links[0].focus(); 
      }
    }

    removeEventListeners() {
      // Remove listeners to avoid memory leaks
      this.links.forEach(item => {
        item.removeEventListener('click', this.setupObservers);
      });
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.closeDrawer);
      }
      document.removeEventListener('keydown', this.handleEscapeKey);
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}
